import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import AccessRestricted from "../universal/access_restricted";

export const requireAuth = (allowedRoles) => (ComposedComponent) => {
    class Authentication extends Component {
        PropTypes = {
            router: PropTypes.object,
        };

        componentWillMount() {
            if (!this.props.authenticated) {
                this.props.history.push('/signin');
            }
        }

        componentWillUpdate(nextProps) {
            if (!nextProps.authenticated) {
                this.props.history.push('/signin');
            }
        }

        render() {
            const {userRole} = this.props;
            if (allowedRoles.includes(userRole)) {
                return <ComposedComponent {...this.props} />;
            }
            else {
                return <AccessRestricted/>;
            }
        }
    }

    function mapStateToProps(state) {
        return {authenticated: state.auth.authenticated, userRole: state.auth.userRole};
    }

    return connect(mapStateToProps)(Authentication);
}



// WEBPACK FOOTER //
// ./src/views/hoc/require_auth.js